var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-full md:pl-10 md:w-3/4" }, [
    _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
      _vm._v("Admin Settings"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-4 group__checkbox" }, [
      _c("div", { staticClass: "select-box" }, [
        _c(
          "label",
          { staticClass: "text-base font-normal", attrs: { for: "published" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.published,
                  expression: "form.published",
                },
              ],
              staticClass: "mr-3",
              attrs: { type: "checkbox", id: "published" },
              domProps: {
                checked: Array.isArray(_vm.form.published)
                  ? _vm._i(_vm.form.published, null) > -1
                  : _vm.form.published,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.form.published,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "published", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "published",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "published", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "check inline-block mr-2" }),
            _vm._v(" "),
            _c("span", { staticClass: "flex-1" }, [_vm._v("Published")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "my-6" }, [
      _c(
        "button",
        {
          staticClass: "button mr-4",
          class: { "opacity-50 cursor-not-allowed": _vm.saving },
          attrs: { disabled: _vm.saving },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
        },
        [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }